import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewingGlass = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 50,
	viewBox: "0 0 100.0 50.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 100,
		height: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("ellipse", {
		cx: 50,
		cy: 25,
		rx: 25,
		ry: 25,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgViewingGlass;
